
/*
Rohini  10/29/2022 3075154998 add classname globally for the textfields and buttons
Lalitha 11/9/2022  3075154998 Rename Button Cancel to Reset
*/
import React, {useEffect, useContext} from 'react';
import {Formik} from 'formik';
import {Button, Grid, TextField, FormHelperText} from '@material-ui/core';
import {useDispatch} from 'react-redux';
import {fetchDispositionCodes} from '../../../../../../redux/reducers/EventTactics/EventTactics';
import {
  resettingFieldData,
} from '../../../../../../redux/reducers/BRE/AddRecordFormat';
import {ThemeContext} from '../../../../../../themes/ThemeProvider';

const ActionForm = ({
  setActionData,
  actionData,
  setActionOpen,
  actionRowData,
  isEditMode,
  setIsEditMode,
  actionCode,
  setParameter,
}) => {
  const dispatch = useDispatch();
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const initialValues = {
    operator: isEditMode && actionRowData?.operator ? actionRowData?.operator : '',
    toField: isEditMode && actionRowData?.toField ? actionRowData?.toField : '',
    fieldCode: '',
    sourceField: isEditMode && actionRowData?.sourceField ? actionRowData?.sourceField : '',
    format: isEditMode && actionRowData?.format ? actionRowData?.format : '',
    type: isEditMode && actionRowData?.type ? actionRowData?.type : '',
    recordFormat: isEditMode && actionRowData?.recordFormat ? actionRowData?.recordFormat : '',
    expression: isEditMode && actionRowData?.expression ? actionRowData?.expression : '',
    actionName: isEditMode && actionRowData?.actionName ? actionRowData?.actionName : '',
    description: isEditMode && actionRowData?.description ? actionRowData?.description : '',
    returnType: isEditMode && actionRowData?.returnType ? actionRowData?.returnType : '',
  };
  useEffect(() => {
    dispatch(fetchDispositionCodes());
  }, []);
  const handleSubmit = (data) => {
    const copiedData = [...actionData];
    if (!isEditMode) {
      copiedData.push({...data});
      setActionData(copiedData);
      setActionOpen(false);
    } else {
      const updatedActionData = copiedData.map((item, i) => {
        if (i === actionCode) {
          return {
            ...item,
            operator: data?.operator,
            toField: data?.toField,
            fieldCode: '',
            sourceField: data?.sourceField,
            format: data?.format,
            type: data?.type,
            recordFormat: data?.recordFormat,
            expression: data?.expression,
            actionName: data?.actionName,
            description: data?.description,
            returnType: data?.returnType,
            sequenceNo: i + 1,
            disposition: data?.disposition,
          };
        } else {
          return {...item};
        }
      });
      setActionData(updatedActionData);
      setActionOpen(false);
      setIsEditMode(false);
    }
  };
  return (
    <div className={classes.dialoguecardStyles}>
      <Formik
        onSubmit={(values) => handleSubmit(values)}
        initialValues={initialValues}
        enableReinitialize
      >
        {(props) => {
          const {values, handleChange, handleSubmit, handleReset, handleBlur, touched, errors} =
            props;
          return (
            <div>
              <form autoComplete="off" noValidate onSubmit={handleSubmit} onReset={handleReset}>
                <div>
                  <Grid container className="global-field-textfields" spacing={2}>
                    <Grid item xs={4} className="pl-md-1 form-group">
                      <TextField
                        className={` ${classes.labelName} ${classes.inputLabel}`}
                        margin="dense"
                        variant="outlined"
                        placeholder={`Enter Description`}
                        label="Description"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        name="description"
                        value={values.description}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                        touched={touched.description}
                        error={Boolean(touched.description && errors.description)}
                      />
                      <FormHelperText style={{color: 'red'}}>
                        {touched.description && errors.description}
                      </FormHelperText>
                    </Grid>
                    <Grid item xs={4} className="form-group">
                      <TextField
                        className={` ${classes.labelName} ${classes.inputLabel}`}
                        margin="dense"
                        variant="outlined"
                        placeholder="Enter Position"
                        label="Position"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        name="position"
                        // value={values.toField}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={4} className="form-group">
                      <TextField
                        margin="dense"
                        variant="outlined"
                        className={` ${classes.labelName} ${classes.inputLabel}`}
                        placeholder={`Enter Field`}
                        label="Field"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        name="field"
                        // value={values.operator}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={4} className="form-group">
                      <TextField
                        margin="dense"
                        variant="outlined"
                        className={` ${classes.labelName} ${classes.inputLabel}`}
                        placeholder={`Enter Type`}
                        label="Type"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        name="type"
                        // value={values.operator}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={4} className="form-group">
                      <TextField
                        margin="dense"
                        variant="outlined"
                        className={` ${classes.labelName} ${classes.inputLabel}`}
                        placeholder={`Enter Format Spec`}
                        label="Format Spec"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        name="formatSpec"
                        // value={values.operator}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={4} className="form-group">
                      <TextField
                        margin="dense"
                        variant="outlined"
                        className={` ${classes.labelName} ${classes.inputLabel}`}
                        placeholder={`Enter Group`}
                        label="Group"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        name="group"
                        // value={values.operator}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                      />
                    </Grid>
                  </Grid>
                </div>
                <div className="text-center">
                  <div className="button-spacing-mb">
                    <Button
                      type="button"
                      onClick={() => handleReset()}
                      variant="outlined"
                      className={`reset-btn mx-1 ${classes.buttonRoot}`}
                    >
                        Reset
                    </Button>
                    <Button
                      type="submit"
                      variant="outlined"
                      className={`search-btn mx-1 ${classes.buttonRoot}`}
                      onClick={() => dispatch(resettingFieldData())}
                    >
                        Save
                    </Button>
                  </div>
                </div>
              </form>
            </div>
          );
        }}
      </Formik>
    </div>
  );
};

export default ActionForm;
